import UniversalTemplate from './UniversalTemplate';
export default UniversalTemplate;